import { LuzmoDashboardComponent } from '@luzmo/react-embed';
import { useMemo } from 'react';

import luzmo from 'common/src/constants/luzmo';

import useLuzmo from 'portal/src/providers/useLuzmo';
import luzmoStyles from 'portal/src/theme/luzmoStyles';

import ContainerLoading from './ContainerLoading';

interface DashboardProps {
  dashboardSlug?: string;
}

const Dashboard = ({ dashboardSlug = undefined }: DashboardProps) => {
  const { dashboardIds, credentials } = useLuzmo();
  const dashboardId = dashboardSlug ? dashboardIds[dashboardSlug] : undefined;
  const { key, token } = credentials;

  const renderedDashboard = useMemo(() => {
    if (!dashboardId || !key || !token) {
      return undefined;
    }

    return (
      <LuzmoDashboardComponent
        // Remount on id change so the embed never keeps the previous dashboard's iframe
        key={dashboardId}
        dashboardId={dashboardId}
        authKey={key}
        authToken={token}
        appServer={luzmo.appServer}
        apiHost={luzmo.apiHost}
        {...luzmoStyles}
      />
    );
  }, [dashboardId, key, token]);

  return renderedDashboard ? (
    renderedDashboard
  ) : (
    <ContainerLoading
      additionalLoadingText="dashboards"
      height="75vh"
      marginTop={18}
      spinnerSize={30}
      spinnerOnTop
    />
  );
};

export default Dashboard;
